import {Component, OnInit} from '@angular/core';
import {UtilsService} from "./services/utils.service";
import {
  ActivatedRoute, Router, RouterEvent, NavigationEnd, NavigationStart,
  RouterStateSnapshot
} from "@angular/router";
import {AuthService} from "./services/auth.service";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

  title = 'app';
  showHeader = true;

  constructor(
    private utilsService: UtilsService,
    private router: Router,
    private authService: AuthService
  ){
    utilsService.menuToggled$.subscribe(() => this.onMenuToggled());
    let that = this;
    //noinspection TypeScriptUnresolvedFunction
    that.router.events.filter(e => e instanceof RouterEvent).subscribe(e => {
      if(e instanceof NavigationStart){
        if(e.url === '/' ){
          if(that.authService.isLoggedIn() === false){
            that.router.navigate(['/login']);
          }
        }
      }

      e instanceof NavigationEnd && (e.urlAfterRedirects.indexOf('error')>-1? that.showHeader = false: that.showHeader = true);

    });
  }


  ngOnInit(): void {
    this.setBodyClass ();
  }
  onMenuToggled = () => {
    this.setBodyClass ();
  };

  setBodyClass (){
    if(this.utilsService.getMenuState() === true){
      document.getElementsByTagName('body')[0].setAttribute('class', 'navigation--open');
    }else{
      document.getElementsByTagName('body')[0].removeAttribute('class');
    }
  };
  ixpaths = {};
  ix = path => {
    let that = this;
    that.utilsService.ix(path).subscribe(url => {
      that.ixpaths[path] = url;
    })
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/app.component.ts